import { render, staticRenderFns } from "./SideNavFooter.vue?vue&type=template&id=c28b1370&scoped=true"
import script from "./SideNavFooter.vue?vue&type=script&lang=js"
export * from "./SideNavFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28b1370",
  null
  
)

export default component.exports